var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cs-button",class:_vm.buttonClasses,style:({
    width: _vm.buttonWidth,
    borderRadius: _vm.buttonRounded,
  }),attrs:{"disabled":_vm.internalDisabled},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }